import { render, staticRenderFns } from "./ExpensesAll.vue?vue&type=template&id=6da6128c&scoped=true&"
import script from "./ExpensesAll.vue?vue&type=script&lang=js&"
export * from "./ExpensesAll.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesAll.vue?vue&type=style&index=0&id=6da6128c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6128c",
  null
  
)

export default component.exports